export enum LoginState {
  enter = 1,
  registrationCode = 2,
  registrationPasswords = 3,
  login = 4,
  forgotPassword = 5,
  forgotPasswordNotCard = 6,
  forgotPasswordCode = 7,
  forgotPasswordEmail = 8,
  forgotPasswordPasswords = 9,
  agreement = 10,
  esiaLogin = 11,
  esiaRegCardUnconfirmed = 12,
  esiaRegCardUsersHandling = 13,
  esiaRegCardDeliveryHandling = 14,
  phoneNumberCheck = 15,
}
